<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <g id="icon_list_birth" transform="translate(1292 2998)">
      <rect
        id="사각형_5816"
        data-name="사각형 5816"
        fill-opacity="0"
        width="24"
        height="24"
        transform="translate(-1292 -2998)"
      />
      <g
        id="그룹_8368"
        data-name="그룹 8368"
        transform="translate(0.173 -0.014)"
      >
        <path
          id="빼기_12"
          data-name="빼기 12"
          fill="#d5d8dc"
          d="M12.5,21a8.5,8.5,0,0,1-5.554-2.067L4.053,13H20.985A8.5,8.5,0,0,1,12.5,21Z"
          transform="translate(-1292 -3002)"
        />
        <path
          id="빼기_11"
          data-name="빼기 11"
          fill="#fc748c"
          d="M19.816,6.986H11.948V0a8.462,8.462,0,0,1,7.868,6.985Z"
          transform="translate(-1290.83 -2995.986)"
        />
        <path
          id="빼기_6"
          data-name="빼기 6"
          fill="#363c43"
          d="M4,8A4,4,0,1,1,8,4,4,4,0,0,1,4,8ZM4,2A2,2,0,1,0,6,4,2,2,0,0,0,4,2Z"
          transform="translate(-1288 -2984)"
        />
        <path
          id="빼기_7"
          data-name="빼기 7"
          fill="#363c43"
          d="M4,8A4,4,0,1,1,8,4,4,4,0,0,1,4,8ZM4,2A2,2,0,1,0,6,4,2,2,0,0,0,4,2Z"
          transform="translate(-1279 -2984)"
        />
        <path
          id="패스_4062"
          data-name="패스 4062"
          fill="#363c43"
          d="M0,0H3.512L4.45,2H0Z"
          transform="translate(-1290.173 -2991)"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
